import { gql } from "@apollo/client/core";

export const LIST_SCHEDULES = gql`
  query ListSchedules($organizationId: ID!) {
    listSchedules(organizationId: $organizationId) {
      id
      orgId
      userId
      targetType
      targetId
      targetName
      enabled
      frequency
      timeOfDay
      dayOfWeek
      dayOfMonth
      timezone
      emailRecipients
      emailSubject
      inputs
      nextRunAt
      lastRunAt
      lastRunStatus
      lastRunError
      insertedAt
      updatedAt
    }
  }
`;

export const CREATE_SCHEDULE = gql`
  mutation CreateSchedule($input: ScheduleCreateInput!) {
    createSchedule(input: $input) {
      id
      orgId
      targetType
      targetId
      targetName
      enabled
      frequency
      timeOfDay
      dayOfWeek
      dayOfMonth
      timezone
      emailRecipients
      emailSubject
      nextRunAt
      insertedAt
      updatedAt
    }
  }
`;

export const DELETE_SCHEDULE = gql`
  mutation DeleteSchedule($scheduleId: ID!) {
    deleteSchedule(scheduleId: $scheduleId)
  }
`;

export const RUN_SCHEDULE_NOW = gql`
  mutation RunScheduleNow($scheduleId: ID!) {
    runScheduleNow(scheduleId: $scheduleId) {
      id
      lastRunAt
      lastRunStatus
    }
  }
`;

export const UPDATE_SCHEDULE = gql`
  mutation UpdateSchedule($scheduleId: ID!, $input: ScheduleUpdateInput!) {
    updateSchedule(scheduleId: $scheduleId, input: $input) {
      id
      orgId
      targetType
      targetId
      targetName
      enabled
      frequency
      timeOfDay
      dayOfWeek
      dayOfMonth
      timezone
      emailRecipients
      emailSubject
      nextRunAt
      insertedAt
      updatedAt
    }
  }
`;

export const LIST_SCHEDULE_RUNS = gql`
  query ListScheduleRuns($organizationId: ID!, $scheduleId: ID!) {
    listScheduleRuns(organizationId: $organizationId, scheduleId: $scheduleId) {
      id
      status
      startedAt
      completedAt
      errorMessage
      resultSummary
      emailSent
      emailError
    }
  }
`;
